module.exports = __webpack_public_path__ + "media/images/img-realestate-12-d5207a0e.jpg";